import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
export abstract class BaseBulkType<T extends FormlyFieldConfig = FormlyFieldConfig>
    extends FieldType<T> {

    hide: boolean = false;
    hasSelectedData: boolean = false;
    loading = false;

    updateCheckbox() {
        // Update the checkbox based on whether the date has a value
        if (this.formControl?.value != null) {
            this.field.formControl!.parent!.get!('filterStatus')!.setValue(this.formControl?.value != null);
        }
    }

    clear() {
        this.formControl?.setValue(null);
        this.field.parent!.get!('filterStatus').formControl?.setValue(false);
    }

    conmuteHide() {
        this.hide = (this.props.hidden == true) && !this.hide;
    }

    getStatus() {
        this.hasSelectedData = this.formControl != undefined && this.formControl?.value !== null;
        this.field.model.hasSelectedData = this.hasSelectedData;
        const status = this.hasSelectedData ? 'field-filtered' : 'field-notSelected';
        return status
    }

    showClear() {
        return this.props["showClear"] && (this.props["showClear"] == true);
    }

    getLoadLabel() {
        return this.loading ? 'Loading' : 'Load';
    }

    getLabel(o: any) {
        const lp = this.props["labelProp"] || 'name';
        return o?.[lp] ?? o?.label ?? String(o);
    }

    getFilterFontStatus() {
        return (this.hasSelectedData && !this.field.model.filterStatus) ? 'filter-disabled-font' : 'filter-enabled-font';
    }

    expandCheckbox() {
        const controlStatus = this.field.parent!.get!('filterStatus').formControl;
        if (controlStatus) {
            controlStatus.valueChanges.subscribe((value) => {
                if (value == true) {
                    this.hide = false;
                } else {
                    this.hide = true;
                }
            });
        }
    }
}